import { memo } from 'react';
import { Select, SelectProps } from '@mui/material';
import { PmiTooltipError } from '../tooltip-error';

type CustomSelectProps<T> = SelectProps<T> & { helperText?: string };
export type PmiSelectProps<T> = Omit<CustomSelectProps<T>, 'value' | 'onChange'>;

const PmiSelectComponent = <T,>({
  children,
  helperText,
  ...props
}: CustomSelectProps<T>): React.ReactElement => {
  return (
    <PmiTooltipError message={helperText} show={props.error}>
      <span style={{ width: '100%' }}>
        <Select {...props} fullWidth size="small">
          {children}
        </Select>
      </span>
    </PmiTooltipError>
  );
};

PmiSelectComponent.displayName = 'Select Field component';

export const PmiSelect = memo(PmiSelectComponent) as typeof PmiSelectComponent;
